import * as React from "react";
const SvgFilterLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 5a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2zm-4 8a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm1.5-4a1 1 0 1 1 0 2h-11a1 1 0 1 1 0-2zM14 17a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2z", clipRule: "evenodd" }));
export default SvgFilterLine;
